import styled from "@emotion/styled";

import { useParams } from "react-router-dom";
import {ConnectedServices} from "../../components/settings/components/ConnectedServices/ConnectedServices";
import {useAppContext} from "../../AppContext";
import {useCallback, useEffect, useState} from "react";

export const MobileConnectedServices = () => {
  const { token } = useParams();
  const { api: { mobileUserApi }, store: { mobileUserStore: { linkedServices } } } = useAppContext();
  
  const [isLoading, setIsLoading] = useState(false);
  const [intervalTimer, setIntervalTimer] = useState<any | null>(null);
  
  const getUserLinkedServices = useCallback(
    async (token: string) => {
      setIsLoading(true);
      try {
        await mobileUserApi.getLinkedServices(token);
      }
      finally {
        setIsLoading(false);
      }
    },
    [mobileUserApi]
  );
  
  const requestLinkedServices = () => {
    if (token) {
      setIsLoading(true);
      let requestTimes = 0;
      const intervalTimer = setInterval(async () => {
        const isDifferent = await mobileUserApi.getLinkedServices(token!);
        
        if (isDifferent) {
          setIsLoading(false);
          clearInterval(intervalTimer);
          requestTimes = 0;
          return;
        }
        
        requestTimes++;
        
        if (intervalTimer && requestTimes > 10) {
          setIsLoading(false);
          clearInterval(intervalTimer);
          requestTimes = 0;
        }
        
      }, 5_000);
      setIntervalTimer(intervalTimer);
    }
  }
  
  const onConnectItem = () => requestLinkedServices();
  
  const onDisconnectItem = () => requestLinkedServices();
  
  useEffect(() => {
    getUserLinkedServices(token || '');
  }, [linkedServices, getUserLinkedServices]);
  
  useEffect(() => {
    return () => {
      if (intervalTimer) {
        clearInterval(intervalTimer);
      }
    };
  }, []);

  return <SWrapper>
    <ConnectedServices
      isLoading={isLoading}
      onServiceItemConnect={onConnectItem}
      onServiceItemDisconnect={onDisconnectItem}
      services={linkedServices}
      shortToken={token} />
  </SWrapper>
}

const SWrapper = styled.div`
  padding: 10px 20px;
`;